<template>
<div class="modal_overlay">
    <div class="check_closing_container" v-if="!openCheck">
        <div class="check_closing"  v-if="weekList">
            <h2> {{ nowWeek }} 주간결산 데이터</h2>
            <table class="table">
                <thead class="table-light">
                    <tr>
                    <th>거래소</th>
                    <th>총액</th>
                    <th>총 인원</th>
                    </tr>
                </thead>
                <tbody v-if="!isLoading">
                    <tr v-if="weekList.length == 0">
                        <td colspan="7">데이터 내역이 없습니다.</td>
                    </tr>
                    <tr v-for="(value, key) in weekList.income" :key="key">
                        <td>{{key}}</td>
                        <td>{{value}}</td>
                        <td>{{ weekList.income_len[key] }}</td>
                    </tr>
                    </tbody>
                    <tbody v-if="isLoading">
                    <td colspan="8" class="list_loading">
                        <div class="loading_spinner">
                        <div class="loading_circle"></div>
                        </div>
                    </td>
                </tbody>
            </table>

            <div class="check_total_container">
                <div class="check_total">
                    금주 결산 총액 <br /> {{ weekList.total_income }}
                </div>  
                <div class="check_total">
                    금주 결산 총 인원 <br /> {{ weekList.total_cnt }}
                </div>
            </div>
          
            <div class="check_button_container">
                <button class="check_btn" @click="closeCheck">닫기</button>
                <button class="check_btn" @click="changeCheck">결산내역 보내기</button>
            </div>
        </div>
    </div>
    <div class="check_closing_container_ok" v-if="weekList && openCheck">
        <div class="check_closing_ok" v-if="weekList.status == 1">
            <h3> 이미 발송된 주간 결산 내역입니다. </h3>
            <div class="check_button_container_ok">
                <button class="check_btn" @click="closeCheck">닫기</button>
            </div>
        </div>
        <div class="check_closing_ok"  v-else-if="weekList.status == 0">
            <h3> 결산 내역을 전송하시겠습니까? </h3>
            <div class="check_button_container_ok">
                <button class="check_btn" @click="closeCheck">닫기</button>
                <button class="check_btn" @click="sendIncome">전송</button>
            </div>
        </div>
        
    </div>
    <ModalMsg
        v-if="modalState"
        :msg="status == 200 ? '성공적으로 보냈습니다.' : '실패하였습니다. 다시 시도해주세요.'"
    />

</div>


</template>
<script>
import { computed } from 'vue';
import { mapActions, mapState, mapMutations } from 'vuex';
import { getItemWithExpireTime } from "@/utils/common";

export default {
    name: 'CheckClosing',
    data() {
        return {
            openCheck: false,
            status: ''
        }
    },
    props: {
        weekList: Array
    },
   
    computed: {
        ...mapState('closing', ['fetchStatus']),
        ...mapState('admin', ['modalState']),
    },
    setup(props) {
        const nowWeek = computed(() => {
            const year = props.weekList.week.slice(0, 4);
            const day = props.weekList.week.slice(4);
            return `${year}년 ${day}주차`;
        });

        return {
            nowWeek,
        };
    },
    methods: {
        ...mapActions('closing', ['getWeekIncome']),
        ...mapMutations('closing', ['setCheckPage']),
        ...mapMutations('admin', ['changeModalState']),

        
        closeCheck() {
            this.setCheckPage(false);
        },

        changeCheck() {
            this.openCheck = true;
        },

        async sendIncome() {
            const admin = getItemWithExpireTime("userInfoObj")?.pk;

            try {
                let response = await this.getWeekIncome(admin);
                this.setCheckPage(false);
                this.openCheck = false;
                this.changeModalState(true);
                this.status = response.status
            }
            catch (err) {
                console.error(err);
                this.status = 500; 
                this.changeModalState(true);
            } 
            finally {
                this.setCheckPage(false);
                this.openCheck = false;
            }
        }

    }

}

</script>
